<template>
   <button
      class="rounded-small relative flex min-w-fit items-center gap-2 px-4"
      :class="{
         'bg-primary text-secondary': variant === 'primary',
         'bg-secondary text-primary': variant === 'secondary',
         'bg-light-grey text-primary': variant === 'light-grey',
         'border-primary bg-primary border text-white': variant === 'filter-active',
         'border-primary text-primary border bg-white': variant === 'filter-inactive',
         'text-primary underline': variant === 'ghost',
         __clickable: !disabled && !isLoading,
         '!bg-light-grey !text-grey border-none': disabled || isLoading,
         'justify-center': true,
         // 'justify-center': !(iconBefore || iconAfter || icon),
         'w-full': grow,
         '!px-2.5': !$slots.default,
         'p-m h-10': !large,
         'h-l h-[50px]': large,
      }"
      type="button"
      :disabled="disabled || isLoading"
   >
      <template v-if="iconBefore">
         <Icon v-show="!isLoading" :name="iconBefore" class="size-5 text-current" />
         <Icon
            v-show="isLoading"
            :name="'spinner'"
            class="size-5 text-current"
            :class="{
               'animate-spin': isLoading,
            }"
         />
      </template>
      <div v-if="$slots.default" class="shrink-0">
         <slot />
      </div>
      <template v-if="iconAfter || icon">
         <Icon v-show="!isLoading" :name="iconAfter || icon || ''" class="size-5 text-current" />
         <Icon
            v-show="isLoading"
            :name="'spinner'"
            class="size-5 text-current"
            :class="{
               'animate-spin': isLoading,
            }"
         />
      </template>

      <Icon
         v-if="!iconAfter && !icon && !iconBefore"
         v-show="isLoading"
         :name="'spinner'"
         class="size-5 text-current"
         :class="{
            'animate-spin': isLoading,
         }"
      />

      <Badge v-if="badge" />
   </button>
</template>

<script lang="ts" setup>
type Props = {
   variant?: 'primary' | 'secondary' | 'light-grey' | 'ghost' | 'filter-active' | 'filter-inactive'
   iconAfter?: string
   icon?: string
   iconBefore?: string
   loading?: boolean
   disabled?: boolean
   grow?: boolean
   large?: boolean
   badge?: boolean
}

const props = withDefaults(defineProps<Props>(), {
   variant: 'primary',
})

const isHydrated = ref(false)
onMounted(() => {
   isHydrated.value = true
})
const isLoading = computed(() => isHydrated.value && props.loading)
</script>
